// extracted by mini-css-extract-plugin
module.exports = {"flex":"flex___2xMoY","text":"text___3MnXS"};